import { PaletteColorOptions, createTheme } from '@mui/material'
const { palette } = createTheme()
const { augmentColor } = palette

const createColor = (mainColor: string) =>
  augmentColor({ color: { main: mainColor } })

declare module '@mui/material/styles' {
  interface CustomPalette {
    accent: PaletteColorOptions
    black: PaletteColorOptions
  }
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    accent: true
    black: true
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: ['Mitr', 'Sarabun'].join(','),
    h1: {
      // DISPLAY LARGE
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '36px',
      lineHeight: '64px',
      letterSpacing: '-0.25px',
    },
    h2: {
      // DISPLAY MEDIUM
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '32px',
      lineHeight: '52px',
    },
    h3: {
      // DISPLAY SMALL
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '28px',
      lineHeight: '44px',
    },
    h4: {
      // HEADLINE LARGE
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '40px',
    },
    h5: {
      // HEADLINE SMALL
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '36px',
    },
    h6: {
      // HEADLINE SMALL
      fontFamily: 'Mitr',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '32px',
    },
    subtitle1: {
      fontFamily: 'Sarabun',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    body1: {
      fontFamily: 'Sarabun',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.5px',
    },
    body2: {
      fontFamily: 'Sarabun',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
  },
  palette: {
    primary: {
      main: '#0079FF',
    },
    error: {
      main: '#FF0038',
    },
    secondary: {
      main: '#00DFA2',
    },
    grey: {
      200: '#C7C7C7',
      600: '#808080',
    },
    text: {
      primary: '#212121',
    },
    success: {
      main: '#34CC25',
    },
    accent: createColor('#153E90'),
    black: createColor('#000000'),
  },
  components: {
    MuiAccordion: {
      defaultProps: {
        square: true,
      },
      styleOverrides: {
        root: {
          '&:before': {
            display: 'none',
          },
          borderBottom: '1px solid #C1C1C1',
          boxShadow: 'none',
          paddingY: '20px',
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
  },
})
